import { BaseViewStore } from 'core/stores';
import { action } from 'mobx';
import { PasswordChangeForm } from 'modules/membership/forms';
import { FulfillmentPasswordStore } from 'modules/membership/stores';
import { notificationError } from 'core/utils';
import { localStorageHandler } from 'core/services';

class PasswordChangeViewStore extends BaseViewStore {
	form = new PasswordChangeForm({
		onSuccess: async () => {
			this.isResetPassword ? await this.resetPassword() : await this.changePassword();
		},
	});
	isResetPassword = false;

	constructor(rootStore) {
		super(rootStore);
		this.fulfillmentPasswordStore = new FulfillmentPasswordStore(rootStore);
		if (rootStore.routerStore.routerState.params.token) {
			this.isResetPassword = true;
			this.form.$('oldPassword').set('rules', '');
		}
	}

	@action.bound
	changePassword = async () => {
		this.suspend();
		try {
			const username = localStorageHandler.get('password-change-username');
			const { newPassword, oldPassword } = this.form.values();
			if (username != null) {
				if (newPassword.toLowerCase().includes(username.split('-')[0].toLowerCase())) {
					this.form.invalidate('PASSWORDCONTAINSUNSERNAME');
				} else {
					await this.fulfillmentPasswordStore.changePassword(username, oldPassword, newPassword);
					this.rootStore.notificationStore.success([
						'LOGINFORM.PASSWORDCHANGESUCCESS',
						{ username: username.split('-')[0] },
					]);
					localStorageHandler.remove('password-change-username');
					this.rootStore.routerStore.goTo('master.app.membership.login');
				}
			} else {
				this.rootStore.notificationStore.error('LOGINFORM.USERNOTFOUND');
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.resume();
	};

	@action.bound
	resetPassword = async () => {
		this.suspend();
		try {
			const { newPassword } = this.form.values();
			const response = await this.fulfillmentPasswordStore.resetPassword({
				newPassword: newPassword,
				token: this.rootStore.routerStore.routerState.params.token,
			});
			this.rootStore.notificationStore.success([response.message]);
			this.rootStore.routerStore.goTo('master.app.membership.login');
		} catch (err) {
			err.data.message
				? this.rootStore.notificationStore.error([err.data.message])
				: notificationError({ store: this.rootStore.notificationStore, err });
			if (err.data.goToLogin) this.rootStore.routerStore.goTo('master.app.membership.login');
		}
		this.resume();
	};
}

export default PasswordChangeViewStore;



// WEBPACK FOOTER //
// ./src/modules/membership/stores/PasswordChangeViewStore.js